<template>
  <el-drawer
    :visible.sync="visible"
    custom-class="warn-drawer"
    :append-to-body="true"
    :with-header="false"
    :show-close="false"
  >
    <div class="drawer-divs">
      <title-model titles="告警信息" heights="76" paddings="0 0.31rem">
        <img
          class="cursor icon_close"
          src="@/assets/image/home/icon_close.png"
          alt=""
          @click="onClose"
        />
      </title-model>
      <div class="warn-lists" v-if="warnList.length">
        <div
          class="flex flex_a_c warn-li"
          v-for="(item, index) in warnList"
          :key="index"
        >
          <img
            class="icon_warn"
            src="@/assets/image/home/icon_warn.png"
            alt=""
          />
          <div class="warn-words font_14">
            <div class="warn-contents c_45">
              {{ item.orgName }} {{ item.content }}！
            </div>
            <div class="warn-time">{{ item.sendTime }}</div>
          </div>
        </div>
      </div>
      <div class="warn-lists t_c" v-else>
        <img class="warn-empty" src="@/assets/image/home/img_none.png" alt="" />
      </div>
      <div class="drawer-footers" v-if="warnTotal >= 10">
        <p class="font_16 cursor footer" @click="toWarnPage">查看更多></p>
      </div>
    </div>
  </el-drawer>
</template>

<script>
/**
 * @description 告警信息抽屉弹窗
 */
import titleModel from "@/components/title-model.vue";
export default {
  components: { titleModel },
  data() {
    return {
      visible: false, // 弹窗是否显示
      // 告警信息列表
      warnList: [],
      warnTotal: 0,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    // 弹窗关闭
    onClose() {
      this.visible = false;
      this.warnList = [];
    },
    // 跳转到告警信息页面
    toWarnPage() {
      this.$router.push("/warn");
    },
  },
};
</script>

<style lang="scss" scoped>
// 警告抽屉
.warn-drawer {
  width: 7.3rem !important;
  padding: 0 0.04rem;
  .icon_close {
    width: 0.3rem;
    height: 0.3rem;
  }
  .warn-lists {
    width: auto;
    // height: 9.94rem;
    height: calc(100vh - 2.02rem);
    margin-top: 0.26rem;
    padding-top: 0;
    margin-left: 0.33rem;
    overflow-y: scroll;
    // 背景
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: transparent;
      border-radius: 4px;
    }
    // 背景
    &::-webkit-scrollbar-track {
      width: 8px;
      height: 8px;
      background-color: transparent;
      border-radius: 4px;
    }
    // 滚动条
    &::-webkit-scrollbar-thumb {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #d9d9d9;
    }
    .warn-li {
      width: 6.59rem;
      background-color: #f5f5f5;
      margin-top: 0.2rem;
      padding: 0.2rem 0.21rem 0.19rem 0.34rem;
      &:nth-child(1) {
        margin-top: 0;
      }
    }
    .warn-contents {
      line-height: 1.5;
    }
    .warn-empty {
      margin-top: 2.5rem;
    }
  }
  .drawer-footers {
    height: 0.81rem;
    color: #32ad9b;
    text-align: center;
    .footer {
      display: inline-block;
      height: 0.81rem;
      width: auto;
      line-height: 0.81rem;
    }
  }
}
</style>
